import React, { useEffect } from 'react'
import { subscribeAndProcess } from 'client/common/pageBus'

export const SOFT_CONTENT_SEARCH_RENDERED = 'SOFT_CONTENT_SEARCH_RENDERED'
const containerId = 'soft-content-container'

const moveElement = () => {
  const child = document.getElementById('softContentOverview')
  document.getElementById(containerId).appendChild(child)
}

const SoftContentContainer = props => {
  const { visible } = props
  useEffect(() => {
    subscribeAndProcess('lister-fragment-SoftContentContainer', SOFT_CONTENT_SEARCH_RENDERED, moveElement)
  }, [])
  const style = {
    display: 'grid',
    visibility: visible ? 'visible' : 'hidden',
    maxHeight: visible ? 'unset' : '0',
    gridArea: 'softContent',
    overflow: visible ? '' : 'hidden'
  }

  return <div id={containerId} style={style} />
}

export default SoftContentContainer
